export default __webpack_public_path__ + "static/media/dolce.1e7d9ff4.jpg";